/**
 * @generated SignedSource<<af649b0fcfc727c1c3f93980c7f6c042>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type secondaryContentItemContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "secondaryContentItemContent";
};
export type secondaryContentItemContent$key = {
  readonly " $data"?: secondaryContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"secondaryContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "secondaryContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "c56d7163891c438ba387d001b0ac6d31";

export default node;
